// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"7d8337d6","353":"05eaa8e5","575":"a3e14461"}[chunkId] + ".chunk.js";
};